import {Injectable, Injector} from '@angular/core';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {AbstractRepositoryV2} from 'src/app/modules/core/service/v2/abstractRepositoryV2';
import {TagModel} from "../../../api/model/tag.model";



@Injectable({providedIn: 'root'})
export class TagRepository extends AbstractRepositoryV2<TagModel>{
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('Tag', serviceElementsFactory, injector);
    }
}
